import axios from '@/app/shared/config/interceptor'

const PREFIX = 'dahboard-tv/delivery-flow-by-boards'

export default {

  getBoardsBy (departmentId) {
    return axios.get(`${PREFIX}/follow-up-boards/${departmentId}`)
  },
  getTotalCardsBy (boardtId) {
    return axios.get(`${PREFIX}/follow-up-boards/total-cards/${boardtId}`)
  },
  getTotalTasksBy (boardtId) {
    return axios.get(`${PREFIX}/follow-up-boards/total-taks/${boardtId}`)
  },
  getTotalCompanyBy (boardtId) {
    return axios.get(`${PREFIX}/follow-up-boards/total-company/${boardtId}`)
  },
  getExistsBoardsWithShowActivitiesTV (profileId) {
    return axios.get(`${PREFIX}/follow-up-boards-activities-tv/${profileId}`)
  }

}
